/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Shop_Tier_Delete_AriaInputs */

const vi_shop_tier_delete_aria = /** @type {(inputs: Shop_Tier_Delete_AriaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Xoá hạng ${i?.name}`)
};

/**

* @param {Shop_Tier_Delete_AriaInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shop_tier_delete_aria = /** @type {((inputs: Shop_Tier_Delete_AriaInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Tier_Delete_AriaInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shop_tier_delete_aria(inputs)
});